import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ProposalManageComponent} from '../proposal-manage/proposal-manage.component';
import {ProposalUploadComponent} from '../proposal-upload/proposal-upload.component';
import {ProposalListService} from './proposal-list.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';

@Component({
  selector: 'app-proposal-list',
  templateUrl: './proposal-list.component.html',
  styleUrls: ['./proposal-list.component.scss']
})
export class ProposalListComponent implements OnInit {
  public displayedColumns: string[] = ['id', 'publishCategory', 'amountFunding', 'user', 'publishTitle', 'isbn', 'descriptionPublication', 'justificationPublishing', 'descriptionCreativeActivityApplicant', 'status', 'createdAt', 'options'];
  public proposals;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private dialog: MatDialog,
    public proposalListService: ProposalListService,
    public router: Router,
  ) {
  }

  ngOnInit(): void {
    this.proposalListService.refreshProposalList();
    this.proposalListService.proposals.subscribe(data => {
      this.proposals = new MatTableDataSource(data);
      this.proposals.paginator = this.paginator;
      this.proposals.sort = this.sort;
    });
  }

  public getStatusText(status) {
    switch (status) {
      case 0:
        return 'Nowy';
        break;
      case 1:
        return 'Zaakceptowany';
        break;
      case 2:
        return 'Odrzucony';
        break;
      case 3:
        return 'Zakończony';
        break;
      default:
        return '';
    }
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.proposals.filter = filterValue.trim().toLowerCase();

    if (this.proposals.paginator) {
      this.proposals.paginator.firstPage();
    }
  }

  public openDialog(id: number) {
    const dialogRef = this.dialog.open(ProposalManageComponent, {
      height: '800px',
      maxHeight: '80%',
      width: '1200px',
      maxWidth: '550px',
      panelClass: 'block-panel',
      data: {
        proposalId: id
      },
    });
  }

  public createNewProposalAgreement() {
    const dialogRef = this.dialog.open(ProposalUploadComponent, {
      height: '800px',
      maxHeight: '80%',
      width: '1200px',
      maxWidth: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
